
import { AjaxService } from '../Ajax/index.jsx';


var TaggedContent = function(taxonomyTerm, primaryOnly = true) {
  this.taxonomyTerm = taxonomyTerm;
  this.primaryOnly = primaryOnly;
};
TaggedContent.prototype.actionName = 'cs:tagged-content';
TaggedContent.prototype.pageSize = 5;
TaggedContent.prototype.fetchPage = function(page) {
  var data = {
    term: this.taxonomyTerm,
    page: page
  };
  if (this.primaryOnly) {
    data['primary-only'] = '1';
  }


  return AjaxService.fetch(this.actionName, data)
    .then(function(response) {
      if (response && response.articles) {
        return response.articles;
      } else {
        return [];
      }
    });
};


export default TaggedContent;
